import styled from "styled-components";
import {
  DARK_BLUE,
  GRAY,
  LIGHT_BLUE,
  LIGHTER_GRAY,
  NEAR_WHITE,
} from "../../../config";

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${NEAR_WHITE};
`;

export const FormHeader = styled.div<{ isOpen: boolean }>`
  display: flex;
  justify-content: space-between;
  height: 40px;
  text-transform: uppercase;
  font-weight: bold;
  cursor: pointer;
  transition: 0.2s ease;
  align-items: end;
  margin-top: 20px;

  h6 {
    font-size: 10px;
    margin: 0px;
    margin-bottom: 2px;
    color: ${NEAR_WHITE};
  }

  #icon-collapse-step {
    transform: ${({ isOpen }) => (isOpen ? "rotate(90deg)" : "none")};
    transition: 0.2s ease;
    margin-right: 16px;
  }
`;

export const FormContent = styled.div`
  padding-top: 20px;

  form {
    border-radius: 10px;
    background: ${GRAY};
    padding: 1.2rem;
    margin-bottom: 25px;
  }

  div.field,
  div.alert-bar {
    margin-bottom: 15px;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  background: transparent;

  .step-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 0px;
    color: ${NEAR_WHITE};
    border-bottom: 3px solid ${NEAR_WHITE};

    .flex-items {
      display: flex;
      align-items: center;
    }

    .step-status-icon {
      margin-right: 15px;
    }

    .tooltip {
      background: ${DARK_BLUE};
      color: ${NEAR_WHITE};
      text-transform: none;
      font-weight: normal;
      width: auto;
      max-width: 450px;
    }
  }
`;

export const HeaderControls = styled.div`
  display: flex;
`;

export const LoadingWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EligibleUsersModalButton = styled.div<{
  hasEligibleUsers: boolean;
}>`
  display: flex;
  gap: 4px;
  margin-right: 20px;
  font-size: 12px;
  font-weight: normal;
  text-transform: none;
  color: ${({ hasEligibleUsers }) =>
    hasEligibleUsers ? LIGHT_BLUE : LIGHTER_GRAY};
  cursor: ${({ hasEligibleUsers }) =>
    hasEligibleUsers ? "pointer" : "default"};
`;

export const SearchListModalContent = styled.div`
  margin-top: 2px;
  height: 300px;
`;

export const SearchListModalBoxLabel = styled.div`
  margin: 20px 0 10px;
`;

export const SearchListModalBox = styled.div`
  font-size: 14px;
  color: ${NEAR_WHITE};
  opacity: 0.87;
  border-radius: 0 0 6px 6px;
  padding: 6px 20px 6px 0;
  height: 190px;
  overflow: scroll;
`;

export const ListItem = styled.div`
  padding: 8px 0;
`;
